'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    name: 'kendo-validator',
    bind: function bind(el, binding, vnode) {
        vnode.context.kendoValidator = kendo.jQuery(el).kendoValidator(binding.value).getKendoValidator();
    }
};